var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreyAiCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_23463_23471)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.38911 5.23835L12 10.8492L17.6109 5.23833C17.9287 4.92056 18.4439 4.92056 18.7617 5.23833C19.0794 5.5561 19.0794 6.07135 18.7617 6.38912L13.1508 12L18.7617 17.6109C19.0794 17.9287 19.0794 18.4439 18.7617 18.7617C18.4439 19.0794 17.9287 19.0794 17.6109 18.7617L12 13.1508L6.38911 18.7617C6.07134 19.0794 5.55612 19.0794 5.23835 18.7617C4.92058 18.4439 4.92058 17.9287 5.23835 17.6109L10.8492 12L5.23833 6.38913C4.92056 6.07136 4.92056 5.55612 5.23833 5.23835C5.5561 4.92058 6.07134 4.92058 6.38911 5.23835Z",
    fill: "#A7B2AF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_23463_23471"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreyAiCross);
export default __webpack_public_path__ + "static/media/grey_ai_cross.dd5693ac98f00776ae5b69261b317dcb.svg";
export { ForwardRef as ReactComponent };